import axios from 'axios';
import {JSON_ROOT} from './config';

const http = axios.create({
  baseURL: JSON_ROOT,
  withCredentials: true
});
// export default helper(http)
export default http
